export default {
    namespaced: true,
    state: {
        buildingName: "",
        residentInfo: {}
    },
    mutations: {
        setBuildingName(state, value) {
            state.buildingName = value
        },
        removeBuildingName(state) {
            state.buildingName = ""
        },
        setResidentInfo(state, data) {
            state.residentInfo = { ...state.residentInfo, ...data }
        },
        removeResidentInfo() {
            state.residentInfo = {}
        },
    },
    actions: {
        setBuildingNameAction({commit}, value) {
            commit('setBuildingName', value)
        },
        removeBuildingNameAction({commit}, value) {
            commit('removeBuildingName', value)
        },
        setResidentAction({commit}, data) {
            commit('setResidentInfo', data)
        },
        removeResidentAction({commit}, data) {
            commit('removeResidentInfo', data)
        },
    },
}
